import './App.css';
import React, { Component } from "react";
import Landing from './pages/Landing.js';
import SplashScreen from './components/SplashScreen.js'

class App extends Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth,
      loading: true,
    };
  }

  async componentDidMount() {
    setTimeout(() => {
        this.setState({ loading : false })
      }, 6000);
}

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render () {
    const { width } = this.state;
    const isMobile = width <= 500;
    const className = (isMobile) ? "AppMobile" : "App";
      return (
        <div className={className}>
          {this.state.loading &&
            <SplashScreen/>
          }
          <Landing />
        </div>
      );
  }
}

export default App;